import SearchPage from 'components/composed/pages/SearchPage';
import { NextSeo } from 'next-seo';

export default function Search() {
  return (
    <>
      <NextSeo title="Free Trademark Search" />
      <SearchPage path="/registration-trademark-search" />
    </>
  );
}
